"use client";

import React from "react";
import { Activity, Shield, Lock, ArrowRight, Terminal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ManagedSecuritySolutions() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: Activity,
    text: "Instant WhatsApp Response"
  }, {
    icon: Shield,
    text: "Unified Lead Inbox"
  }, {
    icon: Lock,
    text: "Automated SEO Boost"
  }];
  return <section data-section-id="145792" id="the-tech-behind-the-magic" className="dark bg-background text-foreground relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden py-24 lg:py-32 radiating-pattern">

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[160px] pointer-events-none z-0" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={contentRef} className={`mx-auto max-w-4xl text-center transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="mb-8 inline-flex items-center gap-2 glass-panel !p-1.5 !px-4 !rounded-full text-sm font-bold uppercase tracking-wider text-primary">
            <Terminal className="size-4" />
            <span>The system that sends an instant WhatsApp to your missed calls.</span>
          </div>

          {}
          <h1 className="h1 mb-8 text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
            <span className="relative inline-block pb-2">
              Your 24/7 Digital Receptionist
              {}
              <span className="absolute bottom-0 left-0 h-2 w-full rounded-sm bg-primary shadow-[0_0_20px_var(--primary)]" />
            </span>
          </h1>

          {}
          <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground sm:text-xl leading-relaxed font-sans">
            Stop losing thousands to missed calls. Our AI-driven system instantly responds to leads via WhatsApp, keeping your tools moving while we handle the admin.
          </p>

          {}
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button asChild size="lg" className="btn-primary w-full sm:w-auto group font-bold px-8">
              <Link to="/PricingPage">
                Secure Founder Spot

                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-secondary/40 text-foreground hover:bg-primary/10 font-bold px-8">
              <Link to="/SilentOperatorPage">
                How It Works
              </Link>
            </Button>
          </div>

          {}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 border-t border-border/30 pt-8">
            {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-sm font-bold text-muted-foreground uppercase tracking-wide">
                <div className="flex size-10 items-center justify-center rounded-md bg-secondary/10 metallic-border">
                  <feature.icon className="size-5 text-primary" />
                </div>
                <span>{feature.text}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}